import { jsxs as e, jsx as r } from "react/jsx-runtime";

import t from "@ui-components-3/ui/lib/utils/classNames";

import { parse as i } from "date-fns";

import s from "./WeekCalendarHourCell.js";

const a = ({days: a, formattedHour: o, className: m, isEmpty: d, zIndex: l}) => e("div", {
    className: t("group/row relative grid", m),
    style: {
        zIndex: l
    },
    children: [ r("div", {
        className: "sticky left-0 z-10 flex items-center justify-end border-r border-t border-transparent bg-white pr-3.5 text-right font-medium",
        children: o
    }), r("div", {
        className: "relative grid grid-cols-7",
        children: a.map(((e, t) => r(s, {
            isEmpty: d,
            hour: i(o, "h a", e)
        }, t)))
    }) ]
});

export { a as default };
//# sourceMappingURL=WeekCalendarHourRow.js.map
